import { btnP, btnS } from "../../../lib/styles.js";
import {
  C, font, mono, PageWrap, SectionHeader, StatPill, StatusPill, Chip, EmptyState, JobCard,
  groupByShoot, ShootGroup,
} from "../components/ui.jsx";
import { getRecipe, getControlSet } from "../lib/recipes.js";
import { SUBJECT_TYPE_LABELS } from "../lib/mockData.js";

export default function QueueView({ jobs, onNewJob, onOpenRecipes, onCancel }) {
  const queued = jobs.filter((j) => j.status === "queued");

  return (
    <PageWrap>
      <SectionHeader
        eyebrow="Processing Queue"
        title="Queue"
        subtitle={queued.length ? `${queued.length} job${queued.length === 1 ? "" : "s"} waiting to process` : "Nothing waiting"}
        right={
          <>
            <StatPill value={queued.length} label="Queued" color={C.amber} />
            <button style={btnS} onClick={onOpenRecipes}>Recipes</button>
            <button style={btnP} onClick={onNewJob}>+ New Processing Job</button>
          </>
        }
      />

      {queued.length === 0 ? (
        <EmptyState
          title="The queue is empty"
          body="Start a processing job by picking a recipe and pointing it at a set of photos."
          action={<button style={btnP} onClick={onNewJob}>+ New Processing Job</button>}
        />
      ) : (
        groupByShoot(queued).map((g) => (
          <ShootGroup key={g.shoot.id} shoot={g.shoot} count={g.jobs.length}>
            {g.jobs.map((job) => <QueueRow key={job.id} job={job} onCancel={onCancel} />)}
          </ShootGroup>
        ))
      )}
    </PageWrap>
  );
}

function QueueRow({ job, onCancel }) {
  const recipe = getRecipe(job.recipeId);
  const control = getControlSet(job.controlSet);

  return (
    <JobCard status="queued">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 14 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 5 }}>
            <span style={{ fontSize: 14, fontWeight: 400, color: C.text }}>{job.label}</span>
            {job.priority > 0 && <Chip color={C.danger}>High priority</Chip>}
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <Chip color={C.amber}>{recipe?.name || "—"}</Chip>
            <span style={{ fontSize: 11, color: C.muted }}>
              {SUBJECT_TYPE_LABELS[job.subjectType] || "Object"} · {control?.label || "—"}
            </span>
          </div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 6 }}>
            <span style={{ fontFamily: mono, fontSize: 10 }}>{job.source}</span>
            {"  ·  "}{job.photoCount} photos{"  ·  "}added {job.created}
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8, flexShrink: 0 }}>
          <StatusPill status="queued" />
          <button
            style={{ ...btnS, padding: "4px 10px", fontSize: 11 }}
            onClick={() => onCancel?.(job.id)}
          >
            Cancel
          </button>
        </div>
      </div>
    </JobCard>
  );
}
